import React, { Component } from 'react'
import {makeStyles} from '@material-ui/core/styles';
import Drawer           from '@material-ui/core/Drawer';
import List             from '@material-ui/core/List';
import ListItem         from '@material-ui/core/ListItem';
import ListItemText     from '@material-ui/core/ListItemText';
import CssBaseline      from '@material-ui/core/CssBaseline';
import Typography       from '@material-ui/core/Typography';
import Divider          from '@material-ui/core/Divider';
import IconButton       from '@material-ui/core/IconButton';
import clsx             from 'clsx';
import Card             from '@material-ui/core/Card';
import CardContent      from '@material-ui/core/CardContent';
import Grid             from '@material-ui/core/Grid';
import Box              from '@material-ui/core/Box';
import {CircularProgressbar} from 'react-circular-progressbar';
import ColAtm           from "../../../atomic/Col/Col";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {dashboardPropertyActions} from "../../../../redux/actions/dasboardActions";
import 'react-circular-progressbar/dist/styles.css';
import ButtonAtm from "../../../atomic/Button/Button";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import {userMenu} from "../../../../redux/actions/menuActions";
import {Link} from "react-router-dom";
import 'pure-react-carousel/dist/react-carousel.es.css';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import {Hidden} from "@material-ui/core";
import {
    APP,
    BOOKING_ENGINE,
    NETWORK,
    OFFER,
    PAYMENT,
    WEB,
    CONTENT_PLACES_FACTS,
    CONTENT_PLACES,
    CONTENT_PLACES_PHOTOS,
    NOT_ALLOWED_DASHBOARD_SHORT,
    NETWORK_COMPETITOR,
    REPUTATION_MANAGEMENT,
    NETWORK_COMPETITOR_DASH
} from "../../../../constants/appUrls.constants";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import {history} from "../../../../utils/history";
import ContentPdfIndex from "./contentPdf";
import ContentPhotosDownload from "./downloadPhotos";
import {getPropertyName, isDefined} from "../../../../utils";
import {propertyProducts} from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "../../Global/NotAllowedPage/NotAllowedPage";
import MultimediaCodeDownload from "./multimediaDownloadCode";
import Charts from "../../Global/Charts";
import ContentCatalogMail from './contentCatalogMail';
import { getProperty } from '../../../../utils';
import BookingFacilityImport from './BookingFacilityImport';

import DashboardBottomActions from "../../../molecules/DashboardBottomActions/DashboardBottomActions";
import {getProfile} from "../../../../redux/actions/User/Profile/profileAction";
const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const PARAM_FACTSHEET = 100;
const PARAM_ONLINE_CATALOG = 101;
const PARAM_AI_CONTENT = 102;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

class DashboardContent extends Component{
    componentDidMount() {
        // Sol menüdeki Panel / Site Ayarları butonları profil e-postasına bakıyor
        this.props.getProfile();
        document.body.style.backgroundColor = "#f4f7fc";
        const {dashboardPropertyActions, userMenu, propertyProducts} = this.props;
        dashboardPropertyActions();
        userMenu();
        propertyProducts();
    }


    render(){

        const dashboard = this.props.property_dashboard;
        const leftDrawer = this.props.left_drawer;
        const amenities = this.props.amenities;
        const general = this.props.general;
        const room = this.props.room;
        const facility = this.props.facility;
        const { t } = this.props;

        const allowedPage = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "content" === item.route)

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        const propertyId = Number(getProperty());

       const hasParameter = (product, paramId) => {
            if (!isDefined(product) || !isDefined(product?.parameters)) return false;
            if (product?.parameters?.length === 0) return true;
            return product.parameters.some(p => p?.product_parameter_id === paramId && p?.is_selected === 1);
        };

        const contentProduct = isDefined(allowedPage[0]) ? allowedPage[0] : null;
        const showFactsheet = hasParameter(contentProduct, PARAM_FACTSHEET);
        const showCatalog = hasParameter(contentProduct, PARAM_ONLINE_CATALOG);

        function Dashboard(props) {
            const classes = useStyles();

            function Sidebar(props) {
                const [isExpanded, setIsExpanded] = React.useState(false);
                const hoverTimeoutRef = React.useRef(null);
                const isNavigatingRef = React.useRef(false);

                const handleMouseEnter = () => {
                    if (isNavigatingRef.current) return;
                    
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    setIsExpanded(true);
                };

                const handleMouseLeave = () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    hoverTimeoutRef.current = setTimeout(() => {
                        if (!isNavigatingRef.current) {
                            setIsExpanded(false);
                        }
                    }, 100);
                };

                const handleLinkClick = (e) => {
                    isNavigatingRef.current = true;
                    
                    const currentExpanded = isExpanded;
                    
                    setTimeout(() => {
                        isNavigatingRef.current = false;
                        setIsExpanded(currentExpanded);
                    }, 500);
                };

                // Cleanup
                React.useEffect(() => {
                    return () => {
                        if (hoverTimeoutRef.current) {
                            clearTimeout(hoverTimeoutRef.current);
                        }
                    };
                }, []);

                const sidebar = (
                    <div className={classes.root}>
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper + " left-sidebar",
                            }}
                            PaperProps={{
                                onMouseEnter: handleMouseEnter,
                                onMouseLeave: handleMouseLeave,
                                style: {
                                    width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                                },
                            }}
                        >
                            <List className={classes.sidebarList}>
                                {props.siderbarItems.map((post, key) => (
                                    <React.Fragment key={key}>
                                        <Link 
                                            to={post.link} 
                                            className={classes.sidebarLink}
                                            onClick={handleLinkClick}
                                        >
                                            <Box 
                                                className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                            >
                                                <Box className={classes.sidebarIconWrapper}>
                                                    <i 
                                                        className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                    />
                                                </Box>
                                                <Typography 
                                                    className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                                >
                                                    {post.text}
                                                </Typography>
                                            </Box>
                                        </Link>
                                    </React.Fragment>
                                ))}
                            </List>
                            {/* Panel + Site Ayarları: logonun üstünde */}
                            <DashboardBottomActions />

                            <Box className={classes.chartsWrapper}>
                                <Charts />
                            </Box>
                        </Drawer>
                    </div>
                );
                return (
                    <>
                        {sidebar}
                    </>
                );
            }

            const siderbarItems = [
                {id: 1, isActive: true, text:  `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:'content'},
                {id: 4, isActive: false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? "web" : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#" },
                {id: 5, isActive: false, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? "booking-engine" : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#" },
                {id: 6, isActive: false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#" },
                {id: 3, isActive: false, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? "offer" : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#" },
                {id: 2, isActive: false, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? "network" : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#" },
                {id: 7, isActive: false, text: (
                    <>
                        {t('enw-input-competitor')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH },
                {id: 8, isActive: false, text: (
                    <>
                        {t('enw-reputation_management-title')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-comments-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
            ];

            const [open, setOpen] = React.useState(false);

            const handleDrawerClose = () => {
                setOpen(false);
            };

            const facilityMenu = () => {
                if( facility.menus  && facility.menus.length > 0 ){
                    return facility.menus.map((menu, key) => (
                            <Link key={key} to={menu.url}>{ t(menu.language_key) } </Link>
                        )
                    );
                }
            }

            const amenitiesMenu = () => {
                if( amenities.menus  && amenities.menus.length > 0 ){
                    return amenities.menus.map((menu, key) => (
                            <Link key={key} to={menu.url}>{ t(menu.language_key) }</Link>
                        )
                    );
                }
            }

            const generalMenu = () => {
                if( general.menus  && general.menus.length > 0 ){
                    return general.menus.map((menu, key) => (
                            <Link key={key} to={menu.url}>{ t(menu.language_key) }</Link>
                        )
                    );
                }
            }

            const roomMenu = () => {
                if( room.menus  && room.menus.length > 0 ){
                    return room.menus.map((menu, key) => (
                            <Link key={key} to={menu.url}>{ t(menu.language_key) }</Link>
                        )
                    );
                }
            }

            return (
                <ColAtm>
                    <Hidden smDown>
                        <ColAtm md={1} style={{ height: 'fit-content'}}>
                            {/*
                            Soldaki drawer butonu şimdilik kaldırıldı!!!
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, open && classes.hide)}
                            >
                                <i className="fas fa-bars" style={{color: '#8f94a2', fontSize: '18px'}} />
                            </IconButton>*/}
                            <Sidebar siderbarItems={siderbarItems} />
                        </ColAtm>
                    </Hidden>
                    <ColAtm sm={8} md={11} className="m-auto">
                        <div className={classes.root}>
                            <CssBaseline />
                            <Drawer
                                className={classes.leftMenu}
                                variant="persistent"
                                anchor="left"
                                open={open}
                                classes={{
                                    paper: classes.leftMenuPaper,
                                }}
                            >
                                <div className={classes.drawerHeader}>
                                    <IconButton className="drawer-back-button" onClick={handleDrawerClose}>
                                        <i className="fas fa-arrow-left" />
                                    </IconButton>
                                </div>
                                <ColAtm className="progress-bar-content">
                                    <CircularProgressbar
                                        className="profile-rate"
                                        value={leftDrawer.total_vote}
                                        text={`${leftDrawer.total_vote}%`}
                                        counterClockwise
                                    />
                                    <p className="profile-power">
                                        Profile Rate
                                        <br/>
                                        <span className="bold-black-text">{leftDrawer.vote_text}</span>
                                    </p>
                                    <Card className="drawer-info">
                                        <CardContent>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                You can increase the profile strength by starting to fill the Photo and amenties fields.
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                    <Divider />
                                    <ColAtm>
                                        <ColAtm>
                                            <Typography className="bold-black-text">
                                                What are the benefits of increasing Profile Strength?
                                            </Typography>
                                        </ColAtm>
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Completing your property's general informations
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Updating room details.
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Upload your property's photos
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Updating amenities.
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Updating services.
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ButtonAtm className="photoUploadButton all-hints-button" buttontext={'All View'} fullwidth={true} />

                                    </ColAtm>
                                </ColAtm>
                            </Drawer>
                            <main
                                className={clsx("dashboard-content", {
                                    [classes.contentShift]: open,
                                })}
                            >
                                <div className={classes.drawerHeader} />
                                <div className={classes.root}>

                                    <Grid container spacing={3}>
                                        {
                                            isDefined(allowedPage[0]) && !allowedPage[0].property_has_product ?
                                                <Grid item xs={12} lg={11}>
                                                    <Hidden xsDown>
                                                        <Card className="p-24 no-buy-product-content">
                                                            <NotAllowedPage />
                                                            <Carousel>
                                                            </Carousel>
                                                        </Card>
                                                    </Hidden>
                                                    <Hidden smUp>
                                                        <Card className="p-24 no-shadow">
                                                            <NotAllowedPage />
                                                            <Carousel>
                                                            </Carousel>
                                                        </Card>
                                                    </Hidden>
                                                </Grid>
                                                :

                                                <>
                                                    <Grid item xs={12} md={6} >
                                                        <Hidden xsDown>
                                                            <Card className="offer-dashboard__box-shadow" item xs={12}>
                                                                <Box className="general_dashboard" component="fieldset" mb={3} borderColor="transparent">
                                                                    <i className="fas fa-hotel" />
                                                                    <Typography className="general-title" gutterBottom>
                                                                    </Typography>
                                                                </Box>
                                                                <CardContent className="min-height-160 pt-0 pr-24 pl-24">
                                                                    <ColAtm>
                                                                        <ColAtm md={9}>
                                                                            <Typography className="red pb-12" gutterBottom variant="h5" component="h2">
                                                                                { t(dashboard.title) }
                                                                            </Typography>
                                                                        </ColAtm>
                                                                        {/*<ColAtm md={3} justify="flex-end" className="count-step">
                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                { t('enw-dashboard-completed_content') }   <span className="red">{dashboard.completed_module}/{dashboard.total_module}</span>
                                                                            </Typography>
                                                                        </ColAtm>*/}
                                                                    </ColAtm>
                                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                                        { t(dashboard.description) }
                                                                    </Typography>
                                                                    <Typography className="last-section" variant="body2" color="textSecondary" component="p">
                                                                        {/* <span className="red">Contact </span> <span> continue information. </span>*/}
                                                                    </Typography>
                                                                </CardContent>
                                                                <ColAtm className="carousel-col general-carousel information-menus">
                                                                    <Carousel slidesPerPage={5}
                                                                              infinite
                                                                              keepDirectionWhenDragging
                                                                              arrowLeft={<i className="fas fa-caret-left" />}
                                                                              arrowRight={<i className="fas fa-caret-right" />}
                                                                              addArrowClickHandler
                                                                              arrows
                                                                    >
                                                                        {generalMenu()}
                                                                    </Carousel>
                                                                </ColAtm>
                                                            </Card>
                                                        </Hidden>
                                                        <Hidden smUp>
                                                            <Card className="offer-dashboard__box-shadow mobile-mb-0 mb-24" item xs={12}>
                                                                <Card>
                                                                    <Grid container spacing={3}>
                                                                        <ColAtm>
                                                                            <ColAtm className="m-general-dashboard pos-relative" item xs={4}>
                                                                                <i className="fas fa-hotel" />
                                                                                {/*<span className="red m-module-count">{dashboard.completed_module}/{dashboard.total_module}</span>*/}
                                                                            </ColAtm>
                                                                            <ColAtm item xs={8} className="border-shadow">
                                                                                <CardContent className="w-100">
                                                                                    <ColAtm>
                                                                                        <ColAtm md={8} xs={12}>
                                                                                            <Typography className="red-title" gutterBottom noWrap>
                                                                                                { t(dashboard.title) }
                                                                                            </Typography>
                                                                                        </ColAtm>
                                                                                    </ColAtm>
                                                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                                                        { t(dashboard.description) }
                                                                                    </Typography>
                                                                                </CardContent>
                                                                            </ColAtm>
                                                                        </ColAtm>
                                                                        <ColAtm className="carousel-col general-carousel information-menus">
                                                                            <Carousel slidesPerPage={3}
                                                                                      infinite
                                                                                      keepDirectionWhenDragging
                                                                                      arrowLeft={<i className="fas fa-caret-left" />}
                                                                                      arrowRight={<i className="fas fa-caret-right" />}
                                                                                      addArrowClickHandler
                                                                                      arrows
                                                                            >
                                                                                {generalMenu()}
                                                                            </Carousel>
                                                                        </ColAtm>
                                                                    </Grid>
                                                                </Card>
                                                            </Card>
                                                        </Hidden>
                                                    </Grid>
                                                    <Grid item xs={12} md={6} >
                                                        <Card className="offer-dashboard__box-shadow mb-24 facility-box" item xs={12}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="facility_dashboard pos-relative" item xs={4}>
                                                                            <i className="far fa-swimmer" />
                                                                            {/*<Hidden smUp>
                                                                                <span className="green m-module-count">{facility.completed_module}/{facility.total_module}</span>
                                                                            </Hidden>*/}
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8} className="border-shadow">
                                                                            <CardContent className="w-100">
                                                                                <ColAtm>
                                                                                    <ColAtm md={8}>
                                                                                        <Typography className="green-title" gutterBottom variant="h5" component="h2">
                                                                                            { t(facility.title) }
                                                                                        </Typography>
                                                                                    </ColAtm>
                                                                                   {/* <Hidden xsDown>
                                                                                        <ColAtm md={4} justify="flex-end" className="count-step">
                                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                                { t('enw-dashboard-completed_content') } <span>{facility.completed_module}/{facility.total_module}</span>
                                                                                            </Typography>
                                                                                        </ColAtm>
                                                                                    </Hidden>*/}
                                                                                </ColAtm>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t(facility.description) }
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                    <ColAtm className="carousel-col general-carousel">
                                                                        <Hidden xsDown>
                                                                            <Carousel slidesPerPage={4}
                                                                                      infinite
                                                                                      keepDirectionWhenDragging
                                                                                      arrowLeft={<i className="fas fa-caret-left" />}
                                                                                      arrowRight={<i className="fas fa-caret-right" />}
                                                                                      addArrowClickHandler
                                                                                      arrows
                                                                            >
                                                                                {facilityMenu()}
                                                                            </Carousel>
                                                                        </Hidden>

                                                                        <Hidden smUp>
                                                                            <Carousel slidesPerPage={2}
                                                                                      infinite
                                                                                      keepDirectionWhenDragging
                                                                                      arrowLeft={<i className="fas fa-caret-left" />}
                                                                                      arrowRight={<i className="fas fa-caret-right" />}
                                                                                      addArrowClickHandler
                                                                                      arrows
                                                                            >
                                                                                {facilityMenu()}
                                                                            </Carousel>
                                                                        </Hidden>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Card>

                                                        <Card className="offer-dashboard__box-shadow room-box" item xs={12}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="room_dashboard pos-relative" item xs={4}>
                                                                            <i className="fal fa-bed-alt" />
                                                                            {/*<Hidden smUp>
                                                                                <span className="purple m-module-count">{room.completed_module}/{room.total_module}</span>
                                                                            </Hidden>*/}
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8} className="border-shadow">
                                                                            <CardContent className="w-100">
                                                                                <ColAtm>
                                                                                    <ColAtm md={8}>
                                                                                        <Typography className="purple-title" gutterBottom variant="h5" component="h2">
                                                                                            { t(room.title) }
                                                                                        </Typography>
                                                                                    </ColAtm>
                                                                                   {/* <Hidden xsDown>
                                                                                        <ColAtm md={4} justify="flex-end" className="count-step">
                                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                                { t('enw-dashboard-completed_content') } <span className="purple">{room.completed_module}/{room.total_module}</span>
                                                                                            </Typography>
                                                                                        </ColAtm>
                                                                                    </Hidden>*/}
                                                                                </ColAtm>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t(room.description) }
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                    <ColAtm className="carousel-col general-carousel">
                                                                        <Hidden xsDown>
                                                                            <ColAtm className="p-0-30">
                                                                                {roomMenu()}
                                                                            </ColAtm>
                                                                        </Hidden>
                                                                        <Hidden smUp>
                                                                            <Carousel slidesPerPage={2}
                                                                                      infinite
                                                                                      keepDirectionWhenDragging
                                                                                      arrowLeft={<i className="fas fa-caret-left" />}
                                                                                      arrowRight={<i className="fas fa-caret-right" />}
                                                                                      addArrowClickHandler
                                                                                      arrows
                                                                            >
                                                                                {roomMenu()}
                                                                            </Carousel>
                                                                        </Hidden>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Card className="offer-dashboard__box-shadow mobile-mb-0 amenities-box" item xs={12}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="blue_dashboard pos-relative" item xs={4}>
                                                                            <i className="far fa-luggage-cart" />
                                                                            {/*<Hidden smUp>
                                                                                <span className="blue m-module-count">{amenities.completed_module}/{amenities.total_module}</span>
                                                                            </Hidden>*/}
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8} className="border-shadow">
                                                                            <CardContent className="w-100">
                                                                                <ColAtm>
                                                                                    <ColAtm md={8}>
                                                                                        <Typography className="blue-title" gutterBottom variant="h5" component="h2">
                                                                                            { t(amenities.title) }
                                                                                        </Typography>
                                                                                    </ColAtm>
                                                                                   {/* <Hidden xsDown>
                                                                                        <ColAtm md={4} justify="flex-end" className="count-step">
                                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                                { t('enw-dashboard-completed_content') } <span className="blue">{amenities.completed_module}/{amenities.total_module}</span>
                                                                                            </Typography>
                                                                                        </ColAtm>
                                                                                    </Hidden>*/}
                                                                                </ColAtm>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t(amenities.description) }
                                                                                </Typography>
                                                                                {/* <BookingFacilityImport/> */}
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                    <ColAtm className="carousel-col general-carousel">
                                                                        <ColAtm className="carousel-col">
                                                                            <Hidden xsDown>
                                                                                <Carousel slidesPerPage={4}
                                                                                          infinite
                                                                                          keepDirectionWhenDragging
                                                                                          arrowLeft={<i className="fas fa-caret-left" />}
                                                                                          arrowRight={<i className="fas fa-caret-right" />}
                                                                                          addArrowClickHandler
                                                                                          arrows
                                                                                >
                                                                                    {amenitiesMenu()}
                                                                                </Carousel>
                                                                            </Hidden>

                                                                            <Hidden smUp>
                                                                                <Carousel slidesPerPage={2}
                                                                                          infinite
                                                                                          keepDirectionWhenDragging
                                                                                          arrowLeft={<i className="fas fa-caret-left" />}
                                                                                          arrowRight={<i className="fas fa-caret-right" />}
                                                                                          addArrowClickHandler
                                                                                          arrows
                                                                                >
                                                                                    {amenitiesMenu()}
                                                                                </Carousel>
                                                                            </Hidden>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Card className="offer-dashboard__box-shadow photo-box" item xs={12}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="photo-upload_dashboard pos-relative" item xs={4}>
                                                                            <i className="far fa-home-alt" />
                                                                           {/* <Hidden smUp>
                                                                                <span className="orange m-module-count">{places.completed_module}/{places.total_module}</span>
                                                                            </Hidden>*/}
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8} className="border-shadow">
                                                                            <CardContent className="w-100">
                                                                                <ColAtm>
                                                                                    <ColAtm md={8}>
                                                                                        <Typography className="orange-title" gutterBottom variant="h5" component="h2">
                                                                                            { t('enw-content-dashboard-places-title') }
                                                                                        </Typography>
                                                                                    </ColAtm>
                                                                                    {/*<Hidden xsDown>
                                                                                        <ColAtm md={4} justify="flex-end" className="count-step">
                                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                                { t('enw-dashboard-completed_content') } <span className="orange">{places.completed_module}/{places.total_module}</span>
                                                                                            </Typography>
                                                                                        </ColAtm>
                                                                                    </Hidden>*/}
                                                                                </ColAtm>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t('enw-content-dashboard-places-desc') }
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                    <ColAtm className="carousel-col general-carousel">
                                                                        <Hidden xsDown>
                                                                            <ColAtm className="p-0-30">
                                                                                <Link key={1} to={CONTENT_PLACES}>{ t('btn-places') }</Link>
                                                                                <Link key={2} to={CONTENT_PLACES_FACTS}>{ t('btn-places_facts') }</Link>
                                                                                <Link key={3} to={CONTENT_PLACES_PHOTOS}>{ t('btn-place_photos') }</Link>
                                                                            </ColAtm>
                                                                        </Hidden>
                                                                        <Hidden smUp>
                                                                            <Carousel slidesPerPage={2}
                                                                                      infinite
                                                                                      keepDirectionWhenDragging
                                                                                      arrowLeft={<i className="fas fa-caret-left" />}
                                                                                      arrowRight={<i className="fas fa-caret-right" />}
                                                                                      addArrowClickHandler
                                                                                      arrows
                                                                            >
                                                                                <Link key={1} to={CONTENT_PLACES}>{ t('btn-places') }</Link>
                                                                                <Link key={2} to={CONTENT_PLACES_FACTS}>{ t('btn-places_facts') }</Link>
                                                                                <Link key={3} to={CONTENT_PLACES_PHOTOS}>{ t('btn-place_photos') }</Link>
                                                                            </Carousel>
                                                                        </Hidden>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={3} className="dashboard-tools" >
                                                            <ContentPhotosDownload />
                                                            {showFactsheet && <ContentPdfIndex />}
                                                            {showCatalog && <ContentCatalogMail />}
                                                            <MultimediaCodeDownload contentCode={leftDrawer.content_code} />
                                                        </Grid>
                                                    </Grid>
                                                </>

                                        }

                                    </Grid>
                                </div>
                            </main>
                        </div>
                    </ColAtm>
                    <style>{`
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                    @media (min-width: 1300px) {
                        .be-container-width, .dashboard-content {
                            padding: 40px 150px 0px 220px !important;
                        }
                    }
                `}</style>
                </ColAtm>
            );
        }


        return(
            <>
                <PageTitle title={ t('enw-dashboard-page_title') } />
                <PageHeaderAtm exitText={ t('btn-properties') } backButton={APP} text={ getPropertyName() } />
                <Container maxWidth="xl">
                    <div className="dashboard-width">
                        <Dashboard dashboard={dashboard} leftDrawer={leftDrawer} propertyProductsReducer={this.props.propertyProductsReducer} />
                    </div>
                </Container>
                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value="content">
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#")}} />
                        <BottomNavigationAction value="booking" icon={<i className="fas fa-calendar-alt" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE :  NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#")}} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? PAYMENT :  NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#")}} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#")}} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#" )}} />
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction
                            value="reputation-management"
                            icon={<i className="fas fa-comments-alt" />}
                            onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#")}}
                        />
                    </BottomNavigation>
                </Hidden>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        property_dashboard : state.dashboardReducers.property_dashboard,
        left_drawer : state.dashboardReducers.left_drawer,
        facility : state.dashboardReducers.facility,
        amenities : state.dashboardReducers.amenities,
        general : state.dashboardReducers.general,
        photos : state.dashboardReducers.photos,
        room : state.dashboardReducers.room,
        places : state.dashboardReducers.places,
        property_menu : state.menuReducers.property_menu,
        propertyProductsReducer : state.propertyProductsReducer
    }
};

export default compose(withTranslation('common')) (connect(mapStateToProps, {getProfile, dashboardPropertyActions, userMenu, propertyProducts})(DashboardContent));
